// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"style_pageHeader__1Ibhz","userName":"style_userName__1LMj7","logout":"style_logout__36_g_","logo-img":"style_logo-img__3gs5Y"};